import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  card: {
    padding: theme.spacing(2),
    margin: "1em auto",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.componentBackground1,
  },
  mainContent: {
    margin: "1em auto",
    width: theme.contentSize.mobilePageWidth,
    [theme.breakpoints.up(theme.breakpoints.values.desktop)]: {
      width: theme.contentSize.pageWidth,
      maxWidth: theme.contentSize.maxPageWidth,
    },
  },
  splitContent: {
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    [theme.breakpoints.up(theme.breakpoints.values.desktop)]: {
      flexDirection: "row",
    },
  },
  basket: {
    marginLeft: "20px",
    flexBasis: 0,
    [theme.breakpoints.down(theme.breakpoints.values.desktop)]: {
      display: "none",
    },
  },
  justifyCenter: {
    justifyContent: "center",
  },
  checkoutDetailsCard: {
    width: "100%",
    marginBottom: "20px",
    backgroundColor: theme.palette.background.default,
  },

  mobileBookingSummary: {
    marginBottom: theme.spacing(4),
  },
  stepper: {
    paddingTop: 0,
    background: "none",

    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      paddingLeft: 0,
    },
  },
  stepContainer: {
    padding: `${theme.spacing(3)}px`,
    marginBottom: `${theme.spacing(3)}px`,
  },
  authStepContainer: {
    border: "none",
  },

  stepperEditIcon: {
    color: theme.palette.primary.main,
    width: "22px",
  },
  paymentWidget: {
    paddingLeft: "0px",
    marginLeft: "0px",
  },
  mobileStep: {
    paddingRight: "0px",
    marginRight: "0px",
  },
  authContainer: {
    background: theme.palette.background.componentBackground1,
  },
  termsBox: {
    margin: 0,
    padding: `${theme.spacing(1)}px 0px`,
    width: "100%",
    alignItems: "flex-start",
  },
  continueAsGuestButton: {
    float: "right",
    marginTop: `${theme.spacing(3)}px`,
  },
  textButton: {
    "&:hover": { backgroundColor: "inherit" },
  },

  checkboxOrRadioContainer: {
    margin: 0,
    padding: `${theme.spacing(1)}px 0px`,
    alignItems: "flex-start",
  },
  checkbox: {
    padding: `0px ${theme.spacing(1)}px`,
  },
  validationFailed: {
    backgroundColor: theme.palette.error.background,
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: "4px",
  },
  makeBookingContainer: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.primary.border}`,
    borderRadius: "16px",
  },
  makeBookingButton: {
    width: "100%",
  },
  hidden: {
    display: "none",
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 20000,
      backgroundColor: theme.palette.background.default,
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "20px",
      backgroundColor: theme.palette.background.default,
    },
  },
}));
